import { render, staticRenderFns } from "./WhereBuy.vue?vue&type=template&id=0600391c"
import script from "./WhereBuy.vue?vue&type=script&lang=js"
export * from "./WhereBuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports